import React from 'react';
import LineChartStatsWrapper from '../LineChartStatsWrapper/LineChartStatsWrapper';

export default function CandidateStats(props) {
  return <LineChartStatsWrapper {...props} title="Candidate Report" id="candidate" />;
}
